import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { Trans, useTranslation } from 'react-i18next';
import MailToCustomerService from '@/components/MailToCustomerService';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const BankAccountManualApproval = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('BankAccountManualApproval.title')}>
      <div className="flex flex-col gap-4">
        <p>{t('BankAccountManualApproval.body')}</p>
        <div className="flex flex-col gap-2">
          <p>{t('BankAccountManualApproval.requirementsTitle')}</p>
          <ul className="mt-0">
            <li>{t('BankAccountManualApproval.requirement1')}</li>
            <li>{t('BankAccountManualApproval.requirement2')}</li>
            <li>{t('BankAccountManualApproval.requirement3')}</li>
            <li>{t('BankAccountManualApproval.requirement4')}</li>
          </ul>
        </div>
        <div className="flex flex-col gap-2">
          <p>{t('BankAccountManualApproval.instructionsTitle')}</p>
          <ol className="mt-0">
            <li>{t('BankAccountManualApproval.document1')}</li>
            <li>{t('BankAccountManualApproval.document2')}</li>
          </ol>
        </div>
        <p>
          <Trans
            t={t}
            i18nKey="BankAccountManualApproval.footer"
            components={{
              customerServiceMail: <MailToCustomerService />,
            }}
          />
        </p>
      </div>
      <ModalActions>
        <Button onClick={closeModal}>{t('BankAccountManualApproval.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default BankAccountManualApproval;
